require('./brokerAlertsConfigCustom.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const classNames = require('classnames');

// @utils
const { FormattedText, formatText } = require('core/i18n').i18n;

// @component
const BrokerConfigCustomItem = require('components/broker/brokerConfigCustomItem/brokerConfigCustomItem');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const BrokerAlertConfigConfirmDelete = require('components/broker/brokerAlertsConfig/brokerAlertConfigConfirmDelete/brokerAlertConfigConfirmDelete');
const { OKButton } = require('components/commons/OKButton/OKButton');

class BrokerAlertsConfigCustom extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            alertToDelete: null
        }

        this.handleRetry = this.handleRetry.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleCanceledDelete = this.handleCanceledDelete.bind(this);
        this.handleConfirmedDelete = this.handleConfirmedDelete.bind(this);
        this.handleCreateAlert = this.handleCreateAlert.bind(this);
    }

    buildItems() {
        const { isFetching, fetchErrorReceived, fetchSuccess } = this.props;
        const retryButton = (
            <OKButton onClick={this.handleRetry}>
                <FormattedText value="myMoneyTransactions-retry" />
            </OKButton>
        );

        if (isFetching) {
            return (<LoadingSection />);
        }

        if (fetchErrorReceived) {
            return (
                <EmptyState
                    primaryText={formatText('broker-lostConnectionFirstLine')}
                    button={retryButton}
                    iconType="nointernet-wealth"
                />
            );
        }

        if (!fetchSuccess) {
            return;
        }

        const { immAlerts, editIsActive, createAlertBox, createAlertBoxAction, createIsExpanded } = this.props;

        if (immAlerts.get('byOrder').size === 0) {
            const createButton = (
                <OKButton onClick={createAlertBoxAction} modifier="link-complementary">
                    <FormattedText value="broker-alertsConfigCreateNewAlert" />
                </OKButton>
            );
            let emptyBlock;

            if (!createIsExpanded) {
                emptyBlock = (
                    <EmptyState
                        primaryText={formatText('broker-alertsCustomNoResults')}
                        button={createButton}
                        iconType="alert-wealth"
                    />
                );
            }
            else {
                emptyBlock = (
                    <EmptyState
                        primaryText={formatText('broker-alertsCustomNoResults')}
                        iconType="alert-wealth"
                    />
                );
            }

            return emptyBlock;
        }

        return immAlerts.get('byOrder').map((alertId) => {
            const immItem = immAlerts.getIn(['byId', alertId]);
            const itemId = `BrokerAlertsConfigCustomItem_${alertId}`;
            const editItem = editIsActive === immItem.get('alertId');

            let editBox;

            if (editItem) {
                editBox = createAlertBox(immItem);
            }

            const customItemClass = classNames(
                'broker-alerts-config-custom__item-container',
                {
                    'broker-alerts-config-custom__item-container--highlighted': editItem
                }
            );

            return (
                <div key={itemId} className={customItemClass}>
                    <BrokerConfigCustomItem
                        id={itemId}
                        immItem={immItem}
                        onHandleEdit={this.handleEdit}
                        onHandleDelete={this.handleDelete}
                        editing={editItem}
                    />

                    {editBox}
                </div>
            );
        });
    }

    buildModalDeleteConfirmation() {
        if (this.state.alertToDelete) {
            return (
                <BrokerAlertConfigConfirmDelete
                    immItem={this.state.alertToDelete}
                    onDeleteAlert={this.handleConfirmedDelete}
                    onCancelDeleteAlert={this.handleCanceledDelete}
                />
            );
        }
    }

    handleCanceledDelete() {
        this.setState({ 'alertToDelete': null });
    }

    handleConfirmedDelete() {
        this.props.onDeleteAlert(this.state.alertToDelete);
        this.setState({ 'alertToDelete': null });
    }

    handleCreateAlert() {
        this.props.createAlertBox();
    }

    handleDelete(alert) {
        this.setState({ 'alertToDelete': alert });
    }

    handleEdit(alert) {
        this.props.onEditAlert(alert);
    }

    handleRetry() {
        this.props.requestDefaultAlerts();
    }

    render() {
        const items = this.buildItems();
        const modalDeleteConfirmation = this.buildModalDeleteConfirmation();

        return (
            <div className="broker-alerts-config-custom no-print-out">
                <h3 className="broker-alerts-config-custom__subtitle">{formatText('broker-alertsConfigPerCustomized')}</h3>
                <div className="broker-alerts-config-custom__group">
                    {items}
                </div>
                {modalDeleteConfirmation}
            </div>
        );
    }
}

BrokerAlertsConfigCustom.propTypes = {
    immAlerts: PropTypes.object.isRequired,
    onDeleteAlert: PropTypes.func.isRequired,
    onEditAlert: PropTypes.func.isRequired,
    requestDefaultAlerts: PropTypes.func.isRequired,
    editIsActive: PropTypes.bool.isRequired,
    createIsExpanded: PropTypes.bool.isRequired,
    createAlertBox: PropTypes.func,
    createAlertBoxAction: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    fetchErrorReceived: PropTypes.bool,
    fetchSuccess: PropTypes.bool
};

module.exports = BrokerAlertsConfigCustom;
